import Enum from "../Enum";

export default Enum.create( {
	IDLE: "IDLE",
	INVOKED: "INVOKED",
	SUCCESS: "SUCCESS",
	ERROR: "ERROR",
} );
